// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PcesZ","footer":"styles_footer__3Jyd3","passCodeTooltip":"styles_passCodeTooltip__35cRs"};